export default __webpack_public_path__ + "static/media/googleplay_de_badge_web.cf0f06b5.png";